import * as React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  
  const handleClear = () => {
    onChange("");
  };

  return (
    <TextField
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || "Search..."}
      variant="outlined"
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {value && ( // Only show clear icon if there's text
              <IconButton onClick={handleClear} size="small">
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
          </InputAdornment>
        ),
        sx: {
          minWidth: "300px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          px: "1.25rem", // Padding inside the input
          py: "0.15rem", // Padding inside the input
          //backgroundColor: "#efefef",
          //color: "#B5B5B5",
          // Target the notchedOutline which draws the border for 'outlined' variant
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // Remove the border
          },
          // Ensure no border on hover or focus as well
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none", // Remove border on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none", // Remove border on focus
          },
          // Adjust input padding specifically if needed
          "& .MuiInputBase-input": {
            padding: "10px 0", // Adjust vertical padding, horizontal is covered by px
          },
        },
      }}
    />
  );
};

export default SearchInput;
